import { useQuery } from 'react-query';
import { setHeaders } from '../../../utils/basic';
import * as config from '../../../app.config';
import axios from 'axios';

const getDdpcrFileDownload = async (plate_uuid) => {
    const headerConfig = setHeaders();
    const { data } = await axios.get(
        `${config.ENDPOINTS["datalake"]}/ddpcr/download/${plate_uuid}`,
        { headers: headerConfig }
    );
    return data;
};

export default function useFetchDdpcrFileDownload(plate_uuid) {
    return useQuery(
        ['ddpcrFileDownload', plate_uuid],
        () => getDdpcrFileDownload(plate_uuid),
        { enabled: false }
    );
}
